import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { useConversion } from "@/context/ConversionContext";

// The three recurring conversion actions.
export function CtaTrio({ variant = "light", prefill = null, className = "" }) {
  const { t, to } = useLang();
  const { openForm, openCalendly } = useConversion();
  const link = variant === "dark" ? "text-white hover:text-white/80" : "text-nek-navy hover:text-nek-blue";
  return (
    <div className={`flex flex-col flex-wrap items-start gap-3 sm:flex-row sm:items-center ${className}`}>
      <button type="button" onClick={() => openForm(prefill)} data-testid="cta-find-solution" className="btn-coral">
        {t.cta.findSolution}
      </button>
      <button
        type="button"
        onClick={openCalendly}
        data-testid="cta-book-appointment"
        className={variant === "dark" ? "btn-outline !bg-transparent !text-white !border-white/30 hover:!border-white" : "btn-navy"}
      >
        {t.cta.bookAppointment}
      </button>
      <Link to={to("/contact")} data-testid="cta-contact-us" className={`inline-flex items-center gap-1.5 font-heading font-semibold ${link} transition-colors`}>
        {t.cta.contactUs} <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
